module.exports = __webpack_public_path__ + "img/arrow-left.329801e0.svg";